(function(){
    'use strict'

    angular
    .module('app.organizadores')
    .controller('Organizadores', Organizadores);

    Organizadores.$inject = ['$animationsSrv', 'OrganizadoresService', 'logger', '$location', 'UserInfoService'];

    function Organizadores($animationsSrv, OrganizadoresService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        var PERMISO_ID = 3;

        vm.organizadores = [];
        vm.title = 'Organizadores';
        vm.permisos = UserInfoService.getPermisos(PERMISO_ID);

        vm.goToEdit = function(organizador){
            
            var path = '/editar-organizador/';

            if(organizador){
                $location.path(path + organizador.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = OrganizadoresService.getAll();

            promise
            .then(function(organizadores){
                vm.organizadores = organizadores;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los organizadores.');
                        break;
                }
            });
        };

        vm.delete = function(organizador){
            var promise = OrganizadoresService.remove(organizador);
            
            promise
            .then(function(response){
                vm.organizadores = vm.organizadores.filter(function(g) {
                    return g.id !== organizador.id;
                });
                logger.success('Organizador eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el organizador');
                        break;
                }
                
            });   
        };

    }
})();